import React from 'react';
import '../components/styles/Section2.css'

const Section2 = () => {
  return (
    <div className='section2'>
        <img src="https://bedrocklauncher.github.io/images/home_tab.png" alt="" />
        <div className="homesection">
          <div className="img">
              <img src="https://bedrocklauncher.github.io/images/version_chooser_full.png" alt="" />
          </div>
          <div className="cont">
            <h2>Versions</h2>
            <p>Get access to almost all versions and switch between <br /> them in an instant.</p>
          </div>
        </div>
        <div className="homesection">
          <div className="cont1">
            <h2>Version Management</h2>
            <p>Add as many versions as you wish with ease!</p>
          </div>
          <div className="img1">
              <img src="https://bedrocklauncher.github.io/images/version_manager.png" alt="" />
          </div>
        </div>
        <div className="homesection">
          <div className="img">
              <img src="https://bedrocklauncher.github.io/images/general_settings_tab.png" alt="" />
          </div>
          <div className="cont">
            <h2>Settings</h2>
            <p>Tweak every nook and cranny to your heart's content</p>
          </div>
        </div>
        <div className="homesection">
          <div className="cont1">
            <h2>Themes</h2>
            <p>Your launcher, your theme!</p>
          </div>
          <div className="img2">
            <img src="https://bedrocklauncher.github.io/images/themes.png" alt="" />
          </div>
        </div>
        <a href="https://github.com/BedrockLauncher/BedrockLauncher" className='btn btn-success'>
          What's being built?
        </a>
    </div>
  )
}

export default Section2